//importing jquery first at the top level and making it globally availble
const  $ = require('jquery');
window.$ = $;
 window.jQuery =$;
globalThis.jQuery = $;
